import { useEventCallback } from '@cian/react-utils';

import { type FC, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { ToTopButton } from '../../components/ToTopButton';

const DEBOUNCE_DELAY = 300;
const SCROLL_THRESHOLD = 1900;

export const ToTopButtonContainer: FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const isNarrow = useListingLayoutIsNarrowSelector();

  const handleScroll = useDebouncedCallback(() => {
    setIsVisible(window.scrollY >= SCROLL_THRESHOLD);
  }, DEBOUNCE_DELAY);

  useEffect(() => {
    if (isNarrow) {
      return (): void => {};
    }

    window.addEventListener('scroll', handleScroll);

    return (): void => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, isNarrow]);

  const handleClick = useEventCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    setIsVisible(false);
  });

  if (!isVisible || isNarrow) {
    return null;
  }

  return <ToTopButton onClick={handleClick} />;
};
